import Link from "next/link";

import Logo from "@/components/icons/logo";
import { cn } from "@/lib/utils";

interface AuthPageBrandProps {
  readonly className?: string;
}

export function AuthPageBrand({
  className,
}: AuthPageBrandProps): JSX.Element {
  return (
    <div className={cn("mb-4 flex justify-center", className)}>
      <Link
        href="/"
        className="inline-flex items-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        aria-label="Kriyastream home"
      >
        <Logo className="h-8 w-auto max-h-9" />
      </Link>
    </div>
  );
}
